import type { ComponentType } from 'react';
import { Route, Routes } from 'react-router-dom';
import MemberSheepLayout from '@/membersheep/pages/MemberSheepLayout';
import MsHomePage from '@/membersheep/pages/MsHomePage';
import MsLegalPage from '@/membersheep/pages/MsLegalPage';
import MsSupportPage from '@/membersheep/pages/MsSupportPage';
import MsNotFoundPage from '@/membersheep/pages/MsNotFoundPage';
import { MS_BASE, MS_LOCALES, MS_PAGE_PATHS, MS_PAGES, msPath, type MsPage } from '@/membersheep/i18n';
import { localizedRoutes } from '@/shared/localizedRoutes';

const MsPrivacyPage = () => <MsLegalPage kind="privacy" />;
const MsTermsPage = () => <MsLegalPage kind="terms" />;

const MS_PAGE_COMPONENTS: Record<MsPage, ComponentType> = {
  [MS_PAGES.home]: MsHomePage,
  [MS_PAGES.privacy]: MsPrivacyPage,
  [MS_PAGES.terms]: MsTermsPage,
  [MS_PAGES.support]: MsSupportPage
};

/** Everything under /membersheep: every page in both locales inside MemberSheepLayout, plus its 404. */
const MemberSheepSection = () => (
  <Routes>
    <Route element={<MemberSheepLayout />}>
      {localizedRoutes({
        locales: MS_LOCALES,
        pages: MS_PAGE_PATHS,
        components: MS_PAGE_COMPONENTS,
        pathFor: msPath,
        base: MS_BASE
      })}
      <Route path="*" element={<MsNotFoundPage />} />
    </Route>
  </Routes>
);

export default MemberSheepSection;
